document.addEventListener('theme:product:add', function(event) {
  addToCartIcomm(event);
});


function addToCartIcomm(event) {
  
  window._imMktOptions = {
    _setType: 'Lead',
    _setDomain: 'www.news.abbacino.es',
    _itemsQuantity: event.detail.response.quantity,
    _amount: (event.detail.response.final_line_price / 100).toFixed(2),
    _extraInfo: `product_id: ${event.detail.response.id}, variant_id: ${event.detail.response.variant_id}`
  };
  
  (function() {
    var icomMkt = document.createElement('script');
    icomMkt.type = 'text/javascript';
    icomMkt.async = true;
    icomMkt.src = (
      document.location.protocol === 'https:' 
      ? 'https://' 
      : 'http://'
    ) + 'externalassets.icommarketing.com/icomMkt_tracking_jquery.min.js';
    
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(icomMkt, s);
  })();
}

// Reordenar selectores de variantes: COLOR antes que TALLA en PDP
(function() {
  function reorderVariantSelectors() {
    const formWidth = document.querySelector('.form__width');
    if (!formWidth) return;
    
    const colorBlock = formWidth.querySelector('.product__block.product__siblings');
    const tallaBlock = formWidth.querySelector('.product__block.product__form__holder');
    
    // WIM W13 · En la ficha ya viene ordenado desde Liquid; solo se mueve si la talla sigue delante
    if (colorBlock && tallaBlock && (tallaBlock.compareDocumentPosition(colorBlock) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      // Insertar el bloque de color antes del bloque de talla
      tallaBlock.parentNode.insertBefore(colorBlock, tallaBlock);
    }
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderVariantSelectors);
  } else {
    reorderVariantSelectors();
  }
})();

// D1 · Ficha sin talla preseleccionada (Webimpacto · auditoría UX, sep 2026)
// El tema marca la primera talla disponible al cargar. Aquí se desmarca la talla
// (salvo si la URL trae ?variant= o solo hay una talla) y se impide añadir al carrito
// sin elegirla, desde la ficha, la barra fija o la compra rápida.
(function() {
  var MSG = 'Selecciona tu talla';
  var SIZE = '[data-wim-size-option]';

  function sizeRadios(wrapper) {
    return wrapper.querySelectorAll('input[type="radio"][data-single-option-selector]');
  }

  function clearError(wrapper) {
    wrapper.classList.remove('wim-size-error');
    var msg = wrapper.querySelector('.wim-size-msg');
    if (msg) msg.remove();
  }

  function initSizes(root) {
    (root || document).querySelectorAll(SIZE).forEach(function(wrapper) {
      if (wrapper.hasAttribute('data-wim-size-init')) return;
      wrapper.setAttribute('data-wim-size-init', '');
      var radios = sizeRadios(wrapper);
      if (radios.length < 2 || wrapper.getAttribute('data-wim-preselected') === 'true') return;
      radios.forEach(function(radio) { radio.checked = false; });
      var label = wrapper.querySelector('[data-option-value]');
      if (label) label.textContent = '';
      wrapper.addEventListener('change', function() { clearError(wrapper); });
    });
  }

  function missingSize(scope) {
    var wrappers = scope.querySelectorAll(SIZE);
    for (var i = 0; i < wrappers.length; i++) {
      var radios = sizeRadios(wrappers[i]);
      if (radios.length > 1 && !wrappers[i].querySelector('input[type="radio"]:checked')) return wrappers[i];
    }
    return null;
  }

  function showError(wrapper) {
    wrapper.classList.add('wim-size-error');
    if (!wrapper.querySelector('.wim-size-msg')) {
      var msg = document.createElement('p');
      msg.className = 'wim-size-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = MSG;
      wrapper.appendChild(msg);
    }
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('[data-add-to-cart], [data-add-to-cart-bar]');
    if (!button) return;
    var scope = button.closest('[data-quick-add-modal]') || button.closest('[data-section-type]') || document;
    var wrapper = missingSize(scope);
    if (!wrapper) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(wrapper);
  }, true);

  function start() {
    initSizes(document);
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.matches(SIZE) || node.querySelector(SIZE))) initSizes(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


// D10 · Contador de fotos en la galería móvil · D8 · aviso de precio por talla (Webimpacto · auditoría UX, sep 2026)
(function() {
  function initCounters() {
    document.querySelectorAll('.product__images--mobile-slider').forEach(function(gallery) {
      if (gallery.querySelector('.wim-gallery-counter')) return;
      var scroller = gallery.querySelector('.product__slides');
      if (!scroller) return;
      var slides = scroller.querySelectorAll(':scope > .product__slide');
      if (slides.length < 2) return;
      var counter = document.createElement('span');
      counter.className = 'wim-gallery-counter';
      counter.setAttribute('aria-hidden', 'true');
      gallery.appendChild(counter);
      function update() {
        var left = scroller.scrollLeft;
        var index = 0;
        var best = Infinity;
        slides.forEach(function(slide, i) {
          var d = Math.abs(slide.offsetLeft - slides[0].offsetLeft - left);
          if (d < best) { best = d; index = i; }
        });
        counter.textContent = (index + 1) + ' / ' + slides.length;
      }
      scroller.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  function initPriceNotes() {
    document.querySelectorAll('[data-wim-price-note]').forEach(function(note) {
      var scope = note.closest('[data-section-type]') || document;
      var sizes = scope.querySelector('[data-wim-size-option]');
      if (!sizes) return;
      function sync() {
        note.hidden = !!sizes.querySelector('input[type="radio"]:checked');
      }
      sizes.addEventListener('change', sync);
      window.setTimeout(sync, 0);
    });
  }

  function start() { initCounters(); initPriceNotes(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* WIM D6 · Al pasar el ratón o enfocar una muestra, la leyenda muestra ese color */
(function () {
  function target(event) {
    var el = event.target && event.target.closest ? event.target.closest('.product__siblings [data-wim-color]') : null;
    return el;
  }
  function label(el) {
    var block = el.closest('.product__siblings');
    return block ? block.querySelector('[data-wim-color-name]') : null;
  }
  function show(event) {
    var el = target(event);
    if (!el) return;
    var name = label(el);
    if (!name) return;
    if (!name.hasAttribute('data-wim-color-default')) name.setAttribute('data-wim-color-default', name.textContent);
    name.textContent = el.getAttribute('data-wim-color');
  }
  function reset(event) {
    var el = target(event);
    if (!el) return;
    var name = label(el);
    if (name && name.hasAttribute('data-wim-color-default')) name.textContent = name.getAttribute('data-wim-color-default');
  }
  document.addEventListener('mouseover', show);
  document.addEventListener('focusin', show);
  document.addEventListener('mouseout', reset);
  document.addEventListener('focusout', reset);
})();

/* WIM W6 · Pestañas de colecciones («Novedades»): la pestaña que no se ve al cargar llega dentro de un <template>.
   Al pulsarla se crea su contenido justo antes de que el tema anime sus productos. */
(function () {
  function hydrateTabs(root) {
    root.querySelectorAll('.tab-content.current template[data-wim-deferred-tab]').forEach(function (tpl) {
      tpl.replaceWith(tpl.content.cloneNode(true));
    });
  }
  document.addEventListener('theme:tab:change', function (event) {
    if (event.target && event.target.querySelectorAll) hydrateTabs(event.target);
  });
})();

/* WIM W7 · «Otros modelos» de la ficha bajo demanda: se pide la sección api-wim-otros-modelos cuando el usuario
   se acerca a los relacionados. Si no devuelve modelos, se usan las recomendaciones de Shopify como hacía el tema. */
(function () {
  var MOBILE_SLIDER = 'grid--mobile-slider';

  function isMobileSlider(ph) {
    return parseInt(ph.style.getPropertyValue('--COLUMNS-MOBILE'), 10) === 0;
  }

  function insert(ph, markup, gridSelector) {
    var tmp = document.createElement('div');
    tmp.innerHTML = markup;
    if (isMobileSlider(ph)) {
      var grid = tmp.querySelector(gridSelector);
      if (grid) grid.classList.add(MOBILE_SLIDER);
    }
    ph.replaceChildren.apply(ph, Array.prototype.slice.call(tmp.childNodes));
  }

  function fallback(ph) {
    var routes = window.theme && window.theme.routes;
    if (!routes || !routes.product_recommendations_url) return;
    var url = routes.product_recommendations_url + '?section_id=api-product-recommendation&limit=' +
      ph.getAttribute('data-limit') + '&product_id=' + ph.getAttribute('data-product-id') + '&intent=related';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-api-related-template]');
        var tmp = document.createElement('div');
        tmp.innerHTML = tpl ? tpl.innerHTML : '';
        var first = tmp.querySelector('[data-grid-item]');
        if (!first) {
          ph.dispatchEvent(new CustomEvent('theme:tab:hide', { bubbles: true }));
          return;
        }
        if (isMobileSlider(ph) && first.parentElement) first.parentElement.classList.add(MOBILE_SLIDER);
        ph.replaceChildren.apply(ph, Array.prototype.slice.call(tmp.childNodes));
      })
      .catch(function () {
        ph.dispatchEvent(new CustomEvent('theme:tab:hide', { bubbles: true }));
      });
  }

  function load(ph) {
    if (ph.hasAttribute('data-wim-loaded')) return;
    ph.setAttribute('data-wim-loaded', '');
    fetch(ph.getAttribute('data-url'))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var tpl = new DOMParser().parseFromString(html, 'text/html').querySelector('template[data-wim-api-otros-modelos]');
        var markup = tpl ? tpl.innerHTML.trim() : '';
        if (!markup || markup.indexOf('data-grid-item') === -1) return fallback(ph);
        insert(ph, markup.split('#WIM_ANCHOR').join(ph.getAttribute('data-anchor') || ''), '[data-grid-slider]');
      })
      .catch(function () { fallback(ph); });
  }

  function init() {
    var placeholders = document.querySelectorAll('[data-wim-other-models]:not([data-wim-loaded])');
    if (!placeholders.length) return;
    if (!('IntersectionObserver' in window)) {
      placeholders.forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.unobserve(entry.target);
          load(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });
    placeholders.forEach(function (ph) { io.observe(ph); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* WIM W9 · Animaciones de entrada desactivadas en «Configuración del tema» (animations_enable: false).
   El theme sigue pintando los atributos data-aos y theme.css quita el scroll-snap de los carruseles mientras
   haya elementos sin .aos-animate; se marcan como animados para que los carruseles se comporten igual que antes. */
(function () {
  if (!window.theme || !window.theme.settings || window.theme.settings.enableAnimations) return;
  function mark(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-aos]')) root.classList.add('aos-animate');
    root.querySelectorAll('[data-aos]:not(.aos-animate)').forEach(function (el) { el.classList.add('aos-animate'); });
  }
  function init() {
    mark(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) mark(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* WIM W19 · Carruseles de la Home por debajo de la primera pantalla: llegan dentro de <template data-wim-lazy>
   y se crean cuando el usuario está a 800 px de ellos (o al instante si el navegador no tiene IntersectionObserver). */
(function () {
  function hydrate(holder) {
    var tpl = holder && holder.querySelector(':scope > template[data-wim-lazy]');
    if (!tpl) return;
    tpl.replaceWith(tpl.content.cloneNode(true));
    holder.classList.add('is-hydrated');
  }
  function init() {
    var holders = document.querySelectorAll('[data-wim-lazy-holder]');
    if (!holders.length) return;
    if (!('IntersectionObserver' in window)) {
      holders.forEach(hydrate);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        hydrate(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    holders.forEach(function (h) { io.observe(h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* WIM W20 · Segunda foto de las tarjetas bajo demanda: se crea al primer contacto con la tarjeta
   (ratón encima, toque o foco), justo antes de que el tema la muestre. */
(function () {
  function hydrate(el) {
    var card = el.closest && el.closest('hover-images, .product-item');
    if (!card) return;
    card.querySelectorAll('template[data-wim-hover-img]').forEach(function (tpl) {
      tpl.replaceWith(tpl.content.cloneNode(true));
    });
  }
  function onEvent(e) {
    if (e.target && e.target.nodeType === 1) hydrate(e.target);
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, onEvent, { passive: true, capture: true });
  });
})();

/* WIM W23 + W24 · Menús bajo demanda. W23 (móvil): los enlaces llegan dentro de un <template> que vive dentro de
   <nav class="drawer__menu"> y se crean con la primera interacción, antes de que al usuario le dé tiempo a
   pulsar el icono. El armazón del cajón (cabecera, botón de cerrar, fondo) se pinta siempre, así que el tema
   inicializa <header-drawer> con sus referencias correctas y no hace falta duplicar ningún elemento: cada
   <mobile-sliderule> se inicializa solo al insertarse, con sus propios botones de ida y de vuelta.
   W24 (escritorio): lo mismo con el contenido de cada panel del mega-menú (snippets/nav-item.liquid). Se pintan siempre
   <hover-disclosure>, el enlace de primer nivel y el contenedor #dropdown-..., que es lo que el tema busca al crearse. */
(function () {
  var EVENTS = ['pointerdown', 'mousemove', 'mouseover', 'touchstart', 'wheel', 'keydown', 'focusin'];
  var done = false;

  /* WIM W24 · El tema reparte los retardos de la animación del mega-menú al crearse (staggerChildAnimations);
     como su contenido llega después, se vuelven a repartir aquí con la misma fórmula. */
  function repartirRetardos() {
    document.querySelectorAll('hover-disclosure').forEach(function (item) {
      var step = 50;
      item.querySelectorAll('[data-stagger]').forEach(function (el, index) {
        el.style.transitionDelay = index * step + 10 + 'ms';
        step *= 0.95;
      });
      item.querySelectorAll('[data-stagger-first]').forEach(function (child, i) {
        var d1 = i * 100;
        child.style.transitionDelay = d1 + 'ms';
        child.parentElement.querySelectorAll('[data-stagger-second]').forEach(function (grandchild, i2) {
          grandchild.style.transitionDelay = d1 + (i2 + 1) * 20 + 'ms';
        });
      });
    });
  }

  function hydrate() {
    if (done) return;
    done = true;
    EVENTS.forEach(function (type) { window.removeEventListener(type, hydrate, true); });
    var tpl = document.querySelector('header-drawer template[data-wim-drawer]');
    if (tpl) tpl.replaceWith(tpl.content.cloneNode(true));
    var megas = document.querySelectorAll('template[data-wim-mega]');
    if (megas.length) {
      megas.forEach(function (t) { t.replaceWith(t.content.cloneNode(true)); });
      repartirRetardos();
    }
  }

  EVENTS.forEach(function (type) { window.addEventListener(type, hydrate, { capture: true, passive: true }); });

  /* Red de seguridad para el SEO: si nadie interactúa (caso de Googlebot y del resto de rastreadores que
     ejecutan JavaScript pero no tocan la página), los menús se crean igual en cuanto el navegador está libre
     después de cargar. Así los enlaces de categoría del menú siguen estando en la página renderizada. */
  function hidratarAlDesocupar() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(hydrate, { timeout: 3000 });
    } else {
      setTimeout(hydrate, 1500);
    }
  }
  if (document.readyState === 'complete') {
    hidratarAlDesocupar();
  } else {
    window.addEventListener('load', hidratarAlDesocupar);
  }

  window.wimHydrateDrawer = hydrate;
})();
